module.exports = __webpack_public_path__ + "static/media/reward-first.a4cecbfe.svg";